module.exports = __webpack_public_path__ + "media/images/opt_filter-2e4a724c45661052c8a545486a56ce04.svg";